var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.5,
    height: 16.5,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1B1B",
    d: "M10.843 8.663c1.296-.825 2.121-2.299 2.121-3.949A4.73 4.73 0 0 0 8.25 0a4.73 4.73 0 0 0-4.714 4.714c0 1.65.825 3.124 2.121 3.948C2.357 9.724 0 12.846 0 16.5h1.179c0-3.89 3.182-7.071 7.071-7.071 3.89 0 7.071 3.182 7.071 7.071H16.5c0-3.654-2.357-6.777-5.657-7.837M8.25 8.25a3.546 3.546 0 0 1-3.536-3.536A3.546 3.546 0 0 1 8.25 1.18a3.546 3.546 0 0 1 3.536 3.535A3.546 3.546 0 0 1 8.25 8.25"
  })));
};
export default SvgUser;